import React from "react";
import { Link } from "react-router";
import {
  closing,
  customerTestimonials,
  hero,
  services,
} from "../lib/homeContent";

export default function Home() {
  return (
    <div className="flex-1">
      <section className="flex flex-col items-center justify-center gap-6 bg-primaryColor p-10 sm:p-14 md:p-20 lg:flex-row lg:gap-24 lg:p-32 xl:p-36">
        <div className="flex w-full flex-col justify-center gap-3 self-end lg:w-2/3 lg:gap-8 xl:w-3/4">
          <h2 className="text-lg font-bold text-secondaryColor md:text-2xl lg:text-4xl">
            {hero?.title}
          </h2>
          <h4 className="text-sm text-white md:text-lg lg:text-xl">
            {hero?.subtitle}
          </h4>
          <p className="text-sm text-white md:text-lg lg:text-xl">
            {hero?.body}
          </p>
        </div>
        <div className="flex flex-col justify-center gap-4 lg:w-1/3 xl:w-1/4">
          {hero?.ctas?.map((cta, index) => {
            return (
              <Link
                to={cta.url}
                key={index}
                className="rounded-3xl bg-white px-4 py-2 text-center text-sm font-bold text-primaryColor shadow-md transition-all hover:bg-gray-300 hover:shadow-lg focus:bg-gray-300 focus:shadow-none active:bg-gray-300 active:shadow-none md:py-3 md:text-base lg:px-5 lg:py-3 xl:px-8 xl:py-4 xl:text-lg"
              >
                {cta.text}
              </Link>
            );
          })}
        </div>
      </section>
      <section className="flex flex-col items-center justify-center gap-6 p-10 sm:p-14 md:p-20 lg:flex-row lg:justify-between lg:gap-24 lg:p-32 xl:p-36">
        <div className="flex w-full flex-col lg:w-1/4">
          <h2 className="text-center text-lg font-bold text-primaryColor md:text-2xl lg:mb-12 lg:text-left lg:text-4xl">
            {services?.title}
          </h2>
          <Link
            to={services?.cta?.url}
            className="hidden rounded-3xl bg-primaryColor px-5 py-3 text-center text-base font-bold text-secondaryColor shadow-md transition-all hover:bg-primaryHover hover:shadow-lg focus:bg-primaryHover focus:shadow-none active:bg-primaryHover active:shadow-none lg:block xl:px-8 xl:py-4 xl:text-lg"
          >
            {services?.cta?.text}
          </Link>
        </div>
        <ul className="flex w-full flex-col gap-4 lg:w-3/4 lg:flex-row lg:flex-wrap lg:justify-evenly lg:gap-6 xl:gap-10">
          {services?.content?.map((item, index) => {
            return (
              <li key={index} className="w-full lg:w-5/12">
                <h3 className="mb-2 text-lg text-primaryColor md:mb-3 md:text-xl lg:mb-4 lg:text-2xl">
                  {item.title}
                </h3>
                <ul className="list-disc">
                  {item?.body?.map((paragraph, paragraphIndex) => {
                    return (
                      <li
                        key={paragraphIndex}
                        className="text-base md:text-lg lg:text-xl"
                      >
                        {paragraph}
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          })}
        </ul>
        <Link
          to={services?.cta?.url}
          className="rounded-3xl bg-primaryColor px-4 py-2 text-sm font-bold text-secondaryColor shadow-md transition-all focus:bg-primaryHover focus:shadow-none active:bg-primaryHover active:shadow-none md:py-3 md:text-base lg:hidden"
        >
          {services?.cta?.text}
        </Link>
      </section>
      <section className="mx-10 mb-12 flex flex-col items-center gap-2 rounded-3xl bg-primaryColor p-10 shadow-xl sm:mx-14 sm:mb-16 md:mx-20 md:mb-20 md:p-14 lg:mx-32 lg:gap-4 lg:p-12 xl:mx-36 xl:p-20">
        <h2 className="text-lg font-bold text-secondaryColor md:text-xl lg:text-2xl">
          {customerTestimonials?.title}
        </h2>

        <p className="text-center text-base text-white md:text-lg lg:text-xl">
          "{customerTestimonials?.body}""
        </p>
      </section>
      <section className="flex flex-col items-center justify-center gap-6 bg-gray-200 p-10 sm:p-14 md:p-20 lg:gap-8 lg:p-32 xl:p-36">
        <h2 className="text-lg font-bold text-primaryColor md:text-xl lg:text-2xl">
          {closing?.title}
        </h2>
        <h3 className="w-full text-left text-base md:text-lg lg:text-center lg:text-xl">
          {closing?.body}
        </h3>
        <div className="flex flex-col justify-center gap-4 lg:w-full lg:flex-row lg:gap-8">
          {closing?.ctas?.map((cta, index) => {
            return (
              <Link
                key={index}
                to={cta.url}
                className="rounded-3xl bg-primaryColor px-4 py-2 text-center text-sm font-bold text-secondaryColor shadow-md transition-all hover:bg-primaryHover hover:shadow-lg focus:bg-primaryHover focus:shadow-none active:bg-primaryHover active:shadow-none md:py-3 md:text-base lg:px-5 lg:py-3 xl:px-8 xl:py-4 xl:text-lg"
              >
                {cta.text}
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
